/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseWorkPackageDtoPage } from '../../models/base-work-package-dto-page';

export interface ListWorkPackages$Params {
  projectId?: string | null;
  workPackageIds?: Array<string>;
  parentId?: string;
  query?: string;
  createdById?: string | null;
  assigneeIds?: Array<string>;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  groupsIds?: Array<string>;
  dynamicFilters?: string;
  isExpired?: boolean | null;
  startFrom?: string | null;
  startTo?: string | null;
  endFrom?: string | null;
  endTo?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<string>;
}

export function listWorkPackages(http: HttpClient, rootUrl: string, params?: ListWorkPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackages.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('parentId', params.parentId, {});
    rb.query('query', params.query, {});
    rb.query('createdById', params.createdById, {});
    rb.query('assigneeIds', params.assigneeIds, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('groupsIds', params.groupsIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('isExpired', params.isExpired, {});
    rb.query('startFrom', params.startFrom, {});
    rb.query('startTo', params.startTo, {});
    rb.query('endFrom', params.endFrom, {});
    rb.query('endTo', params.endTo, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseWorkPackageDtoPage>;
    })
  );
}

listWorkPackages.PATH = '/v0/workPackages';
